/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Remind_ChipInputs */

const en_how_page_remind_chip = /** @type {(inputs: How_Page_Remind_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A text the day before`)
};

const pl_how_page_remind_chip = /** @type {(inputs: How_Page_Remind_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS dzień wcześniej`)
};

/**
* | output |
* | --- |
* | "A text the day before" |
*
* @param {How_Page_Remind_ChipInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_remind_chip = /** @type {((inputs?: How_Page_Remind_ChipInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Remind_ChipInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_remind_chip(inputs)
	return en_how_page_remind_chip(inputs)
});